import React from 'react'

function SvgDemandeRdv() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="17" viewBox="0 0 16 17" fill="none">
    <path d="M2.58333 5.92855H14.25M4.09127 1V2.28586M12.5833 1V2.28571M12.5833 2.28571H4.25C2.86929 2.28571 1.75 3.43697 1.75 4.85712V13.4286C1.75 14.8487 2.86929 16 4.25 16H12.5833C13.964 16 15.0833 14.8487 15.0833 13.4286L15.0833 4.85712C15.0833 3.43697 13.964 2.28571 12.5833 2.28571ZM8.41667 8.5V10.6428M8.41667 10.6428V12.7857M8.41667 10.6428H10.5M8.41667 10.6428H6.33333" stroke="currentColor" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
  )
}

export default SvgDemandeRdv